import { render, staticRenderFns } from "./OldRuleMinMax.vue?vue&type=template&id=a4485c78"
import script from "./OldRuleMinMax.vue?vue&type=script&lang=js"
export * from "./OldRuleMinMax.vue?vue&type=script&lang=js"
import style0 from "./OldRuleMinMax.vue?vue&type=style&index=0&id=a4485c78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports